import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import api from 'api';
import { notice, alert } from 'ducks/notifications';
import autobind from 'autobind-decorator';
import { NavLink, withRouter, Switch, Route } from 'react-router-dom';
import { query } from 'redux-bees';
import SiteHeader from 'components/SiteHeader';
import Services from 'components/Services';
import Deploy from 'components/Deploy';
import Deploys from 'components/Deploys';
import Backups from 'components/Backups';
import Plugins from 'components/Plugins';
import Settings from 'components/Settings';
import CustomDomain from 'components/CustomDomain';
import Https from 'components/Https';
import Modal from 'components/Modal';
import WpSwitch from 'components/WpSwitch';
import Spinner from 'components/Spinner';
import Import from 'components/Import';
import OperationButton from 'components/OperationButton';
import Tooltip from 'components/Tooltip';

@withRouter

@query('site', api.getSite, (call, props) => call({ id: props.match.params.id }))
@query('account', api.getAccount)

export default class Site extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    site: PropTypes.object,
    account: PropTypes.object,
    addSteps: PropTypes.func.isRequired,
    resetSteps: PropTypes.func.isRequired,
    joyrideReset: PropTypes.func.isRequired,
  }

  @autobind
  componentWillMount() {
    this.props.resetSteps();
  }

  @autobind
  handleMigration() {
    const { dispatch, site } = this.props;
    if (confirm('Are you sure?')) {
      return dispatch(api.triggerMigration({ id: site.id }, null))
      .then(() => dispatch(notice('Migrating site')))
      .catch(({ body }) => {
        dispatch(alert(this.t(`error.${body.errors[0].code}`)));
      });
    }
    return true;
  }

  @autobind
  addLastTourSteps() {
    const steps = [
      {
        title: 'Services',
        text: 'Here you can find important information about your WordPress status and how you can access your backend, files and database. When WordPress is switched OFF the area is grayed-out and you cannot access the services',
        selector: '.tour-services',
        position: 'top',
      },
      {
        title: 'Deploys',
        text: 'A deploy is the action of generate static (HTML) copies of your WordPress pages to be served on your Live site. Here you can trigger a new deploy and see the history of your deploys. ',
        selector: '.tour-deploys',
        position: 'top',
      },
      {
        title: 'Backups',
        text: 'HardyPress can save snapshots of your WordPress file and database. A snapshots is automatically generated every time you deploy a new version of your website',
        selector: '.tour-backups',
        position: 'top',
      },
      {
        title: 'Plugins',
        text: 'Here you can check the compatibility of your WordPress plugins with HardyPress ',
        selector: '.tour-plugins',
        position: 'top',
      },
      {
        title: 'Settings',
        text: 'Here you can find some information about your website, you can delete the website, change the name and the PHP version.',
        selector: '.tour-settings',
        position: 'top',
        isFixed: true,
      },
    ];

    this.props.addSteps(steps);
  }

  @autobind
  handleCloseModal() {
    const { site } = this.props;
    this.props.history.push(`/site/${site.id}`);
  }

  renderLoading() {
    return <Spinner size={80} />;
  }


  renderSite() {
    const { site, account } = this.props;

    return (
      <div>
        <SiteHeader
          site={site}
          addSteps={this.props.addSteps}
          joyrideReset={this.props.joyrideReset}
        />
        { site.attributes.wpState === 'migrating' &&
          <div className="space--bottom-5">
            <div className="Deploys__bar warning">
              <div className="Deploys__bar__left">
                Migration in progress
                <Spinner inline size={20} />
              </div>
            </div>
          </div>
        }
        { account.attributes.k8s && !site.attributes.k8s && site.attributes.wpState !== 'migrating' &&
          <div className="space--bottom-5">
            <div className="Deploys__bar warning">
              <div className="Deploys__bar__left">
                <strong>INTERVENTION NEEDED!</strong>
                <br />
                <br />
                Hey, we just deployed a new infrastructure for the HardyPress backend
                (where WordPress Docker containers run), and you can migrate your site with a click.
                <br />
                <br />
                We tried to make this process as seamless as possible and it should not
                last more than five minutes,
                but please take note of the new service URLs and credentials below
                (WordPress, SFTP, phpMyAdmin) after the migration is completed.
                <br />
                <br />
                <strong>The migration is complete when your WordPress is switched on.</strong>
                <br />
                <br />
                This change will allow us to scale properly, build a secure and faster service
                and to add lots on new interesting features so... stay tuned :)
                <br />
                <br />
                Please upgrade before before 31 July, 2019.


              </div>
              {site.attributes.wpState !== 'paused' ?
                <Tooltip label="Switch WordPress OFF to start the migration process">
                  <div className="Deploys__bar__right">
                    <OperationButton
                      className="button button--primary"
                      disabled
                      label={['Upgrade']}
                    />
                  </div>
                </Tooltip>
                :
                <div className="Deploys__bar__right">
                  <OperationButton
                    onClick={this.handleMigration}
                    className="button button--primary"
                    label={['Upgrade']}
                  />
                </div>
              }
            </div>
          </div>
        }
        <div className="Site__navigation space--bottom-3">
          <NavLink
            exact
            to={`/site/${site.id}`}
            className="tour-services Site__navigation__item"
            activeClassName="is-active"
          >
            Services
          </NavLink>
          <NavLink
            to={`/site/${site.id}/deploys`}
            className="tour-deploys Site__navigation__item"
            activeClassName="is-active"
          >
            Deploys
          </NavLink>
          <NavLink
            to={`/site/${site.id}/backups`}
            className="tour-backups Site__navigation__item"
            activeClassName="is-active"
          >
            Backups
          </NavLink>
          <NavLink
            to={`/site/${site.id}/plugins`}
            className="tour-plugins Site__navigation__item"
            activeClassName="is-active"
          >
            Plugins
          </NavLink>
          <NavLink
            to={`/site/${site.id}/settings`}
            className="tour-settings Site__navigation__item"
            activeClassName="is-active"
          >
            Settings
          </NavLink>
          <div className="Site__navigation__actions">
            <WpSwitch
              site={site}
              showText
              addSteps={this.props.addSteps}
              addLastTourSteps={this.addLastTourSteps}
            />
          </div>
        </div>

        <div className="Site">
          <Switch>
            <Route
              exact
              path="/site/:siteId/deploys/:id"
              render={props => <Deploy {...props} site={site} />}
            />
            <Route
              path="/site/:siteId/deploys"
              render={props => <Deploys {...props} site={site} />}
            />
            <Route
              path="/site/:siteId/backups"
              render={props => <Backups {...props} site={site} />}
            />
            <Route
              exact
              path="/site/:siteId/plugins"
              render={props => <Plugins {...props} site={site} />}
            />
            <Route
              exact
              path="/site/:siteId/settings"
              render={props => <Settings {...props} site={site} />}
            />
            <Route
              path="/site/:siteId"
              render={props => <Services {...props} site={site} />}
            />
          </Switch>

          <Route
            exact
            path="/site/:siteId/domain"
            render={() => (
              <Modal wide title="Configure domain" onClose={this.handleCloseModal}>
                <CustomDomain site={site} />
              </Modal>
            )}
          />
          <Route
            exact
            path="/site/:siteId/https"
            render={() => (
              <Modal wide title="SSL configuration" onClose={this.handleCloseModal}>
                <Https site={site} />
              </Modal>
            )}
          />
        </div>
      </div>
    );
  }

  renderImport() {
    const { site } = this.props;

    return (
      <Import site={site} />
    );
  }

  render() {
    const { site } = this.props;

    return (
      <div>

        {
          site && (
            site.attributes.wpState === 'importing' ||
            site.attributes.wpState === 'imported'
          ) &&
            this.renderImport()
        }

        {
          site && (
            site.attributes.wpState !== 'importing' &&
            site.attributes.wpState !== 'imported'
          ) &&
            this.renderSite()
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Site.jsx